import request from '../../config/axiosConfig';
import { CREATE_BLOCK, DELETE_BLOCK, GET_BLOCK_INFO, GET_LIST_BLOCKS, UPDATE_BLOCK } from '../../constants/apiEndPoint';

export const getListBlocksRequest = async (data) => {
  const result = await request({
    url: GET_LIST_BLOCKS,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getBlockInfoRequest = async (data) => {
  const result = await request({
    url: GET_BLOCK_INFO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const createBlocksRequest = async (data) => {
  const result = await request({
    url: CREATE_BLOCK,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const updateBlocksRequest = async (data) => {
  const result = await request({
    url: UPDATE_BLOCK,
    method: 'POST',
    data,
  });
  return result?.data;
};

export const deleteBlocksRequest = async (data) => {
  const result = await request({
    url: DELETE_BLOCK,
    method: 'POST',
    data,
  });
  return result?.data;
};
